<template>
  <div>
    <template v-if="!editable">
      <group class="slds-col slds-p-right--small" :brands="brands" :value="standardRules" :config="config" standard-rules />
    </template>

    <template v-if="localValue && localValue.type">
      <div class="separator slds-p-vertical--x-small" v-if="!editable">{{$t('operator.AND')}}</div>
      <group-item ref="group" v-model="localValue" :scope="scope" :brands="brands" :editable="editable" :exclude="localValue.operator === 'NOT'" v-if="localValue.type === 'rule'" @delete="$emit('deleteRule')" :config="config" />
      <draggable v-model="localValue.conditions" group="rules" v-else>
        <group ref="group" :scope="scope" :brands="brands" v-model="localValue" :editable="editable" @delete="$emit('deleteRule')" :config="config"  />
      </draggable>
    </template>
  </div>
</template>
<script>
import _ from 'lodash'
import Draggable from 'vuedraggable'
import Group from './Group'
import GroupItem from './GroupItem'
export default {
  components: {
    Draggable,
    Group,
    GroupItem
  },
  props: {
    brands: Array,
    config: Object,
    editable: Boolean,
    scope: String,
    standardRules: Object,
    value: Object
  },
  data () {
    return {
      localValue: ''
    }
  },
  created () {
    this.localValue = _.cloneDeep(this.value)
  },
  methods: {
    doUpdate () {
      this.$emit('input', this.localValue)
    },
    update: _.debounce((self) => self.doUpdate(self.localValue), 500),
    validate () {
      if (!this.$refs.group) {
        this.showToast('error', this.$t('campaignDesigner.targetDefinition.validation.missingRuleOrGroup'), 'text')
        return undefined
      } else {
        return this.$refs.group.validate()
      }
    }
  },
  watch: {
    localValue: {
      handler (value) {
        this.update(this)
      },
      deep: true
    },
    value: {
      handler (value) {
        if (JSON.stringify(value) !== JSON.stringify(this.localValue)) { this.localValue = _.cloneDeep(value) }
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
  }

  .separator {
    display: flex;
    align-items: center;
    text-align: center;

    &::before,
    &::after  {
      content: '';
      flex: 1;
      border-bottom: 1px solid #dddbda;
    }

    &:empty {
      margin-left: 0em;
      margin-right: 0em;
    }

    &:not(:empty){
      &::before {
        margin-right: 2em;
      }

      &::after {
        margin-left: 2em;
      }
    }
  }

  .filters-card {
    margin-top: 0;
    flex-grow: 25;
  }

  .full-height {
    height: 100%;
    overflow-y: auto;
  }

  .operator {
    background-color: #F3F2F2;
  }
</style>
